module.exports = __webpack_public_path__ + "static/media/8S.dfeb4fd5.svg";